import {urlBase64ToUint8Array} from "./util/utils";
import SubscriptionService from "./api/subscriptionService";

export const register = () => {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`)
                .then(registration => {
                    console.log('ServiceWorker registration successful with scope: ', registration.scope);
                })
                .catch(error => {
                    console.log('ServiceWorker registration failed: ', error);
                });
        });
    }
}

export const unregister = () => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready
            .then(registration => {
                registration.unregister();
            })
            .catch(error => {
                console.error(error.message);
            });
    }
}

export const subscribeUserToPushNotifications = async () => {
    if (process.env.REACT_APP_VAPID_PUBLIC_KEY) {
        if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
            console.warn("Push notifications are not supported in this browser.");
            return;
        }

        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            console.warn("Notification permission not granted.");
            return;
        }

        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY)
        });

        // Convert subscription to JSON
        const jsonSub = subscription.toJSON();

        if (!jsonSub.keys) {
            throw new Error("Push subscription keys are missing");
        }

        const payload = {
            endpoint: jsonSub.endpoint ?? '',
            keys: {
                p256dh: jsonSub.keys.p256dh,
                auth: jsonSub.keys.auth
            }
        };

        // Send subscription to backend
        await SubscriptionService.subscribeToPushNotifications(payload);

        console.log("User subscribed:", subscription);
    }
    console.error("Vapid public key missing");
}

export const unsubscribeUserFromPushNotifications = async (userId: string) => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
        console.warn("Push notifications are not supported in this browser.");
        return;
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();

    if (subscription) {
        // Inform backend to remove subscription
        await SubscriptionService.unsubscribeFromPushNotifications({endpoint: subscription.endpoint, user_id: userId});

        // Unsubscribe in the browser
        const success = await subscription.unsubscribe();
        console.log(success ? "User unsubscribed from push notifications." : "Failed to unsubscribe.");
    } else {
        console.log("No push subscription found to unsubscribe.");
    }
}